module.exports = __webpack_public_path__ + "img/electric_use.8b48f79f.svg";